export default "__VITE_ASSET__09988bc7__"